/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

// Legacy /chat-with-your-data route — redirects to the combined agent route.
// Kept for backward compatibility with bookmarks and external links.
export default class ChatWithYourDataIndexRoute extends Route {
  @service declare router: RouterService;

  beforeModel() {
    this.router.replaceWith('apps.app.automation.fin-ai-agent.ask');
  }
}
